import type { SxProps, Theme } from '@mui/material/styles';

export const placeholderTextSx: SxProps<Theme> = {
  color: '#737085',
  fontSize: '0.75rem',
  padding: '0.25rem 0.5rem',
};
